import { get } from "lodash";
import { AvailabilityNode } from "./availability";

export default class Site {
  id?: string;
  name: string;
  abbreviation: string;
  url: string;
  logo?: string;
  mcApiKey?: string;
  availabilityLayout?: AvailabilityNode[];

  constructor(params?: Site) {
    this.id = get(params, "id", undefined);
    this.name = get(params, "name", "");
    this.abbreviation = get(params, "abbreviation", "");
    this.url = get(params, "url", "");
    this.logo = get(params, "logo", undefined);
    this.mcApiKey = get(params, "mcApiKey", undefined);
    this.availabilityLayout = get(params, "availabilityLayout", []);
  }
}
